export default __webpack_public_path__ + "static/media/main.bd1bff8a.svg";